"use client"

import styled from "@emotion/styled"
import { extractProperty } from "utils"
import PortContainer from "./PortContainer"
import PortTitle from "./PortTitle"

const PORT_BLUE_IMAGE_URL = "/images/port-blue-static.png"

const StyledSection = styled.section<{ $darkMode?: boolean }>`
  --p-bg: ${(props) =>
    props.$darkMode
      ? props.theme.colors.port.darkBorderColor
      : props.theme.colors.port.lightBackgroundColor};
  --p-text: ${(props) =>
    props.$darkMode
      ? props.theme.colors.port.lightTextColor
      : props.theme.colors.port.lightTextColor};
  --p-border-color: ${(props) =>
    props.$darkMode
      ? props.theme.colors.port.darkBorderColor
      : props.theme.colors.port.lightBorderColor};
  --p-border-color-hover: ${(props) => props.theme.colors.faqTextColorHover};
  --p-item-bg: white;
  --p-item-bg-hover: ${(props) => props.theme.colors.port.lightBackgroundColor};

  padding-block: 60px;
  background-color: var(--p-bg);
  color: var(--p-text);
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 32px;

  ${(props) => props.theme.breakpoints.up("md")} {
    gap: 64px;
    padding-block: 80px;
  }

  position: relative;
  overflow: hidden;
  &::after {
    content: url(${PORT_BLUE_IMAGE_URL});
    display: none;

    position: absolute;
    z-index: 1;
    top: -169px;
    inset-inline-end: -3px;
    ${(props) => props.theme.breakpoints.down("md")} {
      content: "";
      transform: rotate(180deg);
      background-image: url(${PORT_BLUE_IMAGE_URL});
      background-size: contain; /* or cover */
      background-repeat: no-repeat;
      width: 126px;
      height: 128px;
      top: unset;
      bottom: -61px;
    }
  }
`

type PortMarketingTextProps = {
  data: any
}

const PortMarketingText = ({ data }: PortMarketingTextProps) => {
  const blackTitle = extractProperty(data, "blackTitle")
  const blueTitle = extractProperty(data, "blueTitle")
  const text = extractProperty(data, "text")
  const darkMode = extractProperty(data, "darkMode") || false

  // in case data fields are empty, return null
  const hasText = text && text.replace(/<[^>]*>/g, "").trim()
  if (!blackTitle && !blueTitle && !hasText) {
    return null
  }

  return (
    <StyledSection id="port-marketing-text" $darkMode={darkMode}>
      <PortContainer paddingInline={20}>
        {(blackTitle || blueTitle || hasText) && (
          <PortTitle
            normalText={blackTitle}
            highlightedText={blueTitle}
            subtitle={text}
            richSubtitle
            centered
            titleSx={{
              fontSize: {
                xs: "40px",
                md: "60px",
              },
              lineHeight: {
                xs: "125%",
              },
            }}
            subtitleSx={{
              fontWeight: "400",
              lineHeight: "150%",
              textTransform: "capitalize",
              textAlign: "center",
              fontSize: {
                xs: "20px",
                md: "24px",
              },
              letterSpacing: {
                xs: "0.6px",
                md: "unset",
              },
              "& *": {
                textAlign: "center",
              },
              "& ul,ol": {
                maxWidth: "max-content",
                margin: "0 auto",
              },
              "& li": {
                textAlign: "left",
              },
              "& > * ": {
                "&:first-child": {
                  marginTop: 0,
                },
                "&:last-child": {
                  marginBottom: 0,
                },
              },
            }}
          />
        )}
      </PortContainer>
    </StyledSection>
  )
}
export default PortMarketingText
